export function holds(
  permissions: readonly string[],
  required: string,
): boolean {
  const [requiredResource, requiredAction] = required.split(':');
  return permissions.some((permission) => {
    const [resource, action] = permission.split(':');
    return (
      (resource === '*' && action === '*') ||
      (resource === requiredResource &&
        (action === '*' || action === requiredAction))
    );
  });
}
